// How a Google place search is limited. Kept free of Google, React and the app config so the decision
// can be tested on its own (services/maps.js mountPlaceAutocomplete applies it).
//
//  - 'restrict': only places inside the box around the local service circle. Book's default, so a
//    rider can never pick a drop the local fleet does not serve.
//  - 'bias': prefer places near a circle but find anything in India. Intertown's own picker, and
//    Book's drop search when Intertown can take an out-of-area trip (`searchBeyondArea`): a rider who
//    types a town beyond the circle sees it, and choosing it still goes through the service-area
//    check, which hands the place to Book so it can offer "Book with Intertown".
//  - 'open': no limit at all.
//
// Places API (New) hard-rejects a circle radius over 50,000 m: the whole request fails and every
// prediction silently disappears, not just the far ones. So the radius is clamped here.

export const MAX_BIAS_RADIUS_M = 50000;

export function autocompleteSearchMode(options = {}, mapCenter = null) {
  const restrictToServiceArea = options.restrictToServiceArea !== false;
  const searchBeyondArea = restrictToServiceArea && options.searchBeyondArea === true;
  if (restrictToServiceArea && !searchBeyondArea) return { mode: 'restrict', restrictToServiceArea, bias: null };
  const asked = options.locationBias || (searchBeyondArea && mapCenter ? { center: mapCenter, radius: MAX_BIAS_RADIUS_M } : null);
  if (!asked) return { mode: 'open', restrictToServiceArea, bias: null };
  const bias = asked.radius != null
    ? { ...asked, radius: Math.min(Number(asked.radius) || 0, MAX_BIAS_RADIUS_M) }
    : asked;
  return { mode: 'bias', restrictToServiceArea, bias };
}
